module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label",
    class: _vm.getClasses(),
    attrs: {
      "title": _vm.getTitle()
    }
  }, [_vm._v(_vm._s(_vm.getLabel()))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1eb3acde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/ClientStatus.vue
// module id = 971
// module chunks = 34